export { default } from './part-feature-case-item';
